import { render, staticRenderFns } from "./SettingsSubscription.vue?vue&type=template&id=3dbae6b0&"
import script from "./SettingsSubscription.vue?vue&type=script&lang=js&"
export * from "./SettingsSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports